import { Chip, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { CommunicationInsightsPageRow } from "../server/supabase-communication-insights-page-service";

type Props = {
  insight: CommunicationInsightsPageRow;
  fieldDisplayName?: string;
};

export const InsightsInsightRow: FC<Props> = ({ insight, fieldDisplayName }) => {
  const engagementRate = Math.round(insight.ctr * 100);
  const delta = Math.abs(Math.round((insight.ctr - insight.overall_ctr) * 100));
  const aboveOrBelow = insight.direction === "above_average" ? "above" : "below";
  const fieldLabel = fieldDisplayName ?? insight.field_key;
  const text = `This ${fieldLabel}'s engagement rate is ${engagementRate}%, ${delta} percentage points ${aboveOrBelow} average`;

  return (
    <Stack spacing={0.5}>
      <Chip
        label={insight.segment_value}
        size="small"
        variant="outlined"
        color={insight.direction === "above_average" ? "success" : "warning"}
        sx={{ alignSelf: "flex-start" }}
      />
      <Typography variant="body2">{text}</Typography>
    </Stack>
  );
};
